import React, { Component } from 'react';
import './ResultAnalysisMenuBar.css'

export default class ResultAnalysisMenuBar extends Component {
    handleOnClick = (section) => (e) => {
        this.props.onMenuChange(section);
    }
    render() {
        const section = this.props.section;
        return (
            <div className="ResultAnalysisMenuBar">
                <ul>
                    <li className={section==="price" ? "selected" : ""} onClick={this.handleOnClick('price')}>株価</li>
                    <li className={section==="estimate" ? "selected" : ""} onClick={this.handleOnClick('estimate')}>業績・予想</li>
                    <li className={section==="corpinfo" ? "selected" : ""} onClick={this.handleOnClick('corpinfo')}>企業概要</li>
                </ul>
            </div>
        );
    }
}